import { registerPlugin } from "@capacitor/core";
import type { SaveBackend } from "../save/backends";

/**
 * The save's durable copy in the iOS shell (X11): Capacitor Preferences (UserDefaults), which iOS keeps with the app
 * and never evicts under storage pressure the way it may a web view's IndexedDB. The plugin's JS package is not
 * bundled: the native bridge answers `registerPlugin("Preferences")` by name, and only these three calls are used.
 */
interface PreferencesPlugin {
  configure(o: { group: string }): Promise<void>;
  get(o: { key: string }): Promise<{ value: string | null }>;
  set(o: { key: string; value: string }): Promise<void>;
  remove(o: { key: string }): Promise<void>;
}

const Preferences = registerPlugin<PreferencesPlugin>("Preferences");

export class PreferencesBackend implements SaveBackend {
  /** Preferences' key group: keeps the save apart from anything else in the app's UserDefaults. */
  static readonly Group = "HighmarchSave";
  readonly name = "preferences";

  private constructor() {}

  static async open(): Promise<PreferencesBackend> {
    await Preferences.configure({ group: PreferencesBackend.Group });
    return new PreferencesBackend();
  }

  async get(key: string): Promise<string | null> { return (await Preferences.get({ key })).value ?? null; }
  set(key: string, value: string): Promise<void> { return Preferences.set({ key, value }); }
  delete(key: string): Promise<void> { return Preferences.remove({ key }); }
}
